import { useLang } from "../../lib/LangContext";
import { homeCopy } from "../../lib/homeCopy";
import { ChapterLabel, Reveal, StoryImage } from "./Story";

// 02 Experience · 03 Craft · 04 Transformation — alternating editorial split layouts.
const STORY = {
  experience: { index: 2, images: ["experience-arrival", "experience-walk"], reverse: false },
  craft: { index: 3, images: ["craft-brush", "craft-microfiber"], reverse: true },
  transformation: { index: 4, images: ["transformation-front", "transformation-wide"], reverse: false },
};

export const StoryChapter = ({ id }) => {
  const { lang } = useLang();
  const copy = homeCopy(lang);
  const c = copy[id];
  const cfg = STORY[id];
  const filmTag = copy.services.film;
  return (
    <section id={id} data-testid={`chapter-${id}`} data-chapter={cfg.index} className="relative bg-[#050505] py-16 md:py-24 overflow-hidden">
      <div className={`max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center`}>
        <div className={`lg:col-span-7 ${cfg.reverse ? "lg:order-2" : ""}`}>
          <Reveal className="relative group">
            <StoryImage name={cfg.images[0]} alt={c.title} tag={filmTag} className="aspect-[16/10]" testid={`chapter-${id}-image`} />
          </Reveal>
          <Reveal delay={0.15} className={`hidden md:block w-1/2 -mt-24 relative z-10 group ${cfg.reverse ? "mr-auto -ml-8" : "ml-auto -mr-8"}`}>
            <StoryImage name={cfg.images[1]} widths={[640, 1280]} alt="" sizes="(min-width: 1024px) 28vw, 50vw" className="aspect-[16/10] border border-white/10 shadow-2xl shadow-black/60" />
          </Reveal>
        </div>
        <div className={`lg:col-span-5 ${cfg.reverse ? "lg:order-1" : ""}`}>
          <Reveal><ChapterLabel index={cfg.index} label={copy.chapters[cfg.index - 1]} testid={`chapter-${id}-label`} /></Reveal>
          <Reveal delay={0.08} as="h2" className="mt-8 font-heading text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            {c.title}
          </Reveal>
          <Reveal delay={0.16} as="p" className="mt-6 text-zinc-300 text-[15px] md:text-[17px] leading-relaxed max-w-md">
            {c.text}
          </Reveal>
          {c.points && (
            <Reveal delay={0.24} as="ul" className="mt-10 space-y-4 border-t border-white/10 pt-8 max-w-md">
              {c.points.map((p) => (
                <li key={p} className="flex items-center gap-4 text-[15px] text-zinc-200">
                  <span className="w-1.5 h-1.5 bg-gold" /> {p}
                </li>
              ))}
            </Reveal>
          )}
          {c.note && <Reveal delay={0.24} as="p" className="mt-10 text-[12px] text-zinc-500 leading-relaxed max-w-md" >{c.note}</Reveal>}
        </div>
      </div>
    </section>
  );
};
